const actions = {
  GET_REGULAR_DOCUMENT: 'GET_REGULAR_DOCUMENT',
  GET_BOARD_DOCUMENT: 'GET_BOARD_DOCUMENT',
  UPDATE_BOARD_DOCUMENT: 'UPDATE_BOARD_DOCUMENT',
  GET_REGULAR_DOCUMENT_END: 'GET_REGULAR_DOCUMENT_END',
  GET_BOARD_DOCUMENT_END: 'GET_BOARD_DOCUMENT_END',
  UPDATE_BOARD_DOCUMENT_END: 'UPDATE_BOARD_DOCUMENT_END',
  GET_ORDER: 'GET_ORDER',
  GET_ORDER_END: 'GET_ORDER_END',
  GET_ORDER_DETAIL: 'GET_ORDER_DETAIL',
  GET_ORDER_DETAIL_END: 'GET_ORDER_DETAIL_END',
  POST_REFUND_BANK: 'POST_REFUND_BANK',
  POST_REFUND_BANK_END: 'POST_REFUND_BANK_END',
  POST_REFUND_STAFF: 'POST_REFUND_STAFF',
  POST_REFUND_STAFF_END: 'POST_REFUND_STAFF_END',
  PUT_REFUND_RETRY: 'PUT_REFUND_RETRY',
  PUT_REFUND_RETRY_END: 'PUT_REFUND_RETRY_END',
  GET_RECEIPT_SETTING: 'GET_RECEIPT_SETTING',
  GET_RECEIPT_SETTING_END: 'GET_RECEIPT_SETTING_END',
  UPDATE_RECEIPT_SETTING: 'UPDATE_RECEIPT_SETTING',
  UPDATE_RECEIPT_SETTING_END: 'UPDATE_RECEIPT_SETTING_END',
  PUT_RECEIPT_QUERY: 'PUT_RECEIPT_QUERY',
  PUT_RECEIPT_QUERY_END: 'PUT_RECEIPT_QUERY_END',
  PUT_RECEIPT_ISSUE: 'PUT_RECEIPT_ISSUE',
  PUT_RECEIPT_ISSUE_END: 'PUT_RECEIPT_ISSUE_END',
  PUT_RECEIPT_INVALIDATE: 'PUT_RECEIPT_INVALIDATE',
  PUT_RECEIPT_INVALIDATE_END: 'PUT_RECEIPT_INVALIDATE_END',
  UPDATE_PAYMENT_DETAIL: 'UPDATE_PAYMENT_DETAIL',
  UPDATE_PAYMENT_DETAIL_END: 'UPDATE_PAYMENT_DETAIL_END',
};

export default actions;
